import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5001';
const API_URL = `${API_BASE}/api`;
const STORAGE_KEY = 'tellurvision_auth';

interface AuthStorageShape {
  token?: string;
}

export interface UserProfile {
  id: string;
  username: string;
  email: string;
  role: string;
  accountStatus: string;
  createdAt?: string;
  updatedAt?: string;
}

function getAuthToken(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as AuthStorageShape;
    return typeof parsed.token === 'string' ? parsed.token : null;
  } catch {
    return null;
  }
}

export const fetchUserProfile = async (): Promise<UserProfile> => {
  const token = getAuthToken();
  if (!token) {
    throw new Error('Not authenticated');
  }

  const response = await axios.get<UserProfile>(`${API_URL}/users/profile`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const updateUserProfile = async (
  updates: Partial<Pick<UserProfile, 'username' | 'email'>>,
): Promise<UserProfile> => {
  const token = getAuthToken();
  if (!token) {
    throw new Error('Not authenticated');
  }

  const response = await axios.put<UserProfile>(`${API_URL}/users/profile`, updates, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const changeUserPassword = async (
  currentPassword: string,
  newPassword: string,
): Promise<void> => {
  const token = getAuthToken();
  if (!token) {
    throw new Error('Not authenticated');
  }

  await axios.post(
    `${API_URL}/users/change-password`,
    { currentPassword, newPassword },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};
